let graphicLayer; //展示线标记和面标记功能临时用。

/* 异步加载 一些弹窗组件 */
const MarkListTree = () => import("./markListTree/MarkListTree");
// const MarkSettings = () => import('../../components/tables/markList/markSettings/MarkSettings.vue');
const MarkDirectory = () => import("./markDirectory/MarkDirectory.vue");
const MarkRecord = () => import("./markRecord/MarkRecord.vue");

//按需加载
import {
  getMarkList,
  addMark,
  editMark,
  deleteMark,
  getFileDetail,
  deleteFile,
} from "../../../api/api";

import { EventBus } from "../../../static/js/event-bus.js";

export default {
  components: {
    MarkListTree,
    // MarkSettings,
    MarkDirectory,
    MarkRecord,
  },
  props: {},
  data() {
    return {
      markList_show: true,

      getData: [], //保存请求后台数据获取到的一维json数组【原始数组】
      treeData: [],
      treeExpandAll: true,
      treeNodeKey: "id",

      open_mark_box: "", //当前打开的标记子弹窗，最多只同时显示一个子弹窗。
      isFold: false,
    };
  },
  mounted() {
    // alert(22)
    this.initTreeData();

    graphicLayer = new mars3d.layer.GraphicLayer();
    this.$GLOBAL.map.addLayer(graphicLayer);

    EventBus.$on("updateCartesian", (param) => {
      //当标记点移动时，根据标记的id获取到标记的表单信息并显现在表单上，方便准确定位和编辑、更新等。

      // this.$refs.markRecord.form.position = param.cartesianXYZ; //这行代码不应该写在这里，因为如果只加载了MarkList弹窗，还没有加载MarkRecord弹窗，那么这段代码应该会报出this.$refs.markRecord未定义之类的错误。

      //根据编辑对象的id找到对应标记列表里的数据项，对应进行编辑。
      let tempData = "";
      if (param.mType === "point") {
        tempData = param.cartesianXYZ;
      } else if (param.mType === "polyline" || param.mType === "polygon") {
        tempData = param.points;
      }
      if (tempData) {
        this.editMarkRecordByUid(param.mType, param.graphic.uuid, tempData);
      }
    });
  },

  methods: {
    // 初始化列表
    initTreeData() {
      //axios请求 获取数据 注意将parentId:'0'转为parentId:'',以方便el-tree正常识别和显示数据。此外注意将字段名首位字母改为小写。
      let tempdata = [];
      let that = this;

      let modelData = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
      };
      getMarkList(modelData).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          tempdata = res.data.data;

          for (let i = 0; i < tempdata.length; i++) {
            if (
              tempdata[i]["x"] !== "" &&
              tempdata[i]["y"] !== "" &&
              tempdata[i]["z"] !== ""
            ) {
              tempdata[i]["position"] =
                tempdata[i]["x"] +
                "," +
                tempdata[i]["y"] +
                "," +
                tempdata[i]["z"];
            }
            tempdata[i]["parentId"] = tempdata[i]["pid"];
            tempdata[i]["desc"] = tempdata[i]["description"];
            if (tempdata[i]["markType"] === "content") {
              tempdata[i]["markType"] = "directory";
            }
            tempdata[i]["markIconColor"] = tempdata[i]["icon"];
            tempdata[i]["markTextColor"] = tempdata[i]["textColor"];
            tempdata[i]["markShared"] = tempdata[i]["owner"];
            tempdata[i]["fileData"] = tempdata[i]["localFiles"];
            if (tempdata[i]["localFiles"]) {
              tempdata[i]["fileList"] = tempdata[i]["localFiles"].split(",");
            }
          }

          tempdata = that.initMarkArray(tempdata);
          that.getData = tempdata.map((i) => {
            if (i.parentId === "0") {
              i.parentId = "";
            }
            return i;
          });
          // console.log(JSON.parse(JSON.stringify(tempdata)));
          // console.log(222222222222);
          that.refreshTree();
          //alert(1);
        } else {
          that.getData = [];
          that.refreshTree();
        }
      });

      // tempdata = [{
      // 	children: [],
      // 	name: 'YSTJ-01（K127+000 ~ k16....)',
      // 	desc: 'YSTJ-01（K127+000 ~ k16....) 描述',
      // 	parentId: '1',
      // 	id: '2',
      // 	markType: 'directory',
      // 	markIconColor: '',
      // 	markTextColor: '',
      // 	position: '',
      // }, {
      // 	children: [],
      // 	name: 'YSTJ-02（K127+000 ~ k16....)1',
      // 	desc: 'YSTJ-02（K127+000 ~ k16....) 描述',
      // 	parentId: '1',
      // 	id: '9',
      // 	markType: 'point',
      // 	markIconColor: '#ffd700',
      // 	markTextColor: '#ffd700',
      // 	position: '108.575151,25.949959,-135.3',
      // }];
    },
    refreshTree() {
      this.treeData = this.getTree(this.getData, "");
      // console.log(JSON.parse(JSON.stringify(this.getData)));
      // console.log(444);
      // console.log(JSON.parse(JSON.stringify(this.treeData)));
    },
    getTree(data, root, idTxt, pidTxt, pushTxt) {
      var idTxt = idTxt || "id";
      var pidTxt = pidTxt || "parentId";
      var pushTxt = pushTxt || "children";
      // 递归方法
      function getNode(id) {
        var node = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i][pidTxt] == id) {
            let tdata = getNode(data[i][idTxt]);
            if (!tdata) {
              tdata = [];
            }
            data[i][pushTxt] = tdata;
            node.push(data[i]);
          }
        }
        if (node.length == 0) {
          return;
        } else {
          return node;
        }
      }
      // 使用根节点
      return getNode(root);
    },
    markList_click() {
      //alert("触发");
      if (this.$GLOBAL.markDrawGraphicLayer) {
        this.$GLOBAL.markDrawGraphicLayer.clear();
      }

      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      this.$emit("markListBox_close");
    },

    // markSettings() {
    // 	this.$emit('markSettings_open');
    // },

    //弹出表单新增标记目录
    createMarkDirectory(data) {
      let fdata = data.filter(function(fp) {
        return fp.markType === "directory";
      });

      this.open_mark_box = "MarkDirectory";

      this.$refs.markDirectory.addDirectory(fdata);
    },
    //目录树添加新增的标记目录
    addMarkDirectory(data) {
      this.$refs.MarkListTree.treeAddItem(data);

      this.getData.push(data);
    },
    // 弹出表单修改标记目录
    editTreeItem(data) {
      // 打开编辑弹窗
      let fdata = this.getData.filter(function(fp) {
        return fp.markType === "directory" && fp.id !== data.id;
      });

      this.open_mark_box = "MarkDirectory";

      this.$refs.markDirectory.editDirectory(data, fdata);
    },
    // 目录树更新已修改成功的标记目录
    updateTreeItem(data) {
      this.$refs.MarkListTree.treeEditItem(data);
    },
    // 删除目录
    deleteTreeItem(data) {
      let that = this;
      this.$confirm("确定删除该目录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除树节点
          if (data.children == undefined || data.children.length <= 0) {
            //axios请求删除节点代码
            let mddData = {
              projectId: parseInt(
                window.sessionStorage.getItem("nowProjectId")
              ),
              id: data.id,
            };
            deleteMark(mddData).then((res) => {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log(444444444444);
              if (res.data.success && res.data.code === 204) {
                that.initTreeData(); //请求后台数据刷新
                //this.$refs.MarkListTree.treeDeleteItem(data); //本地刷新，演示效果用,但会导致一个问题，就是旧数据里的数据没有更新。
                //同时还要关闭第二个弹窗，避免已删除的信息的编辑弹窗还在。
                that.open_mark_box = "";

                that.$notify({
                  title: "已成功删除该标记目录。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert(
                  "删除该标记目录保存失败了，请再试一次吧~",
                  "删除失败",
                  {
                    confirmButtonText: "确定",
                    type: "error",
                    callback: (action) => {},
                  }
                );
              }
            });
          } else {
            this.$alert("删除失败，因为该目录不为空目录。", "友情提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    //弹出新增标记弹窗
    createMarkRecord(data, mType = "point") {
      console.log(data);
      let fdata = data.filter(function(fp) {
        return fp.markType === "directory";
      });

      // 注意当MarkRecord的父组件MarkList组件的弹窗出现时，MarkRecord组件就已经加载了，mounted方法也会执行一遍。
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        //alert(2);
        this.$GLOBAL.markDrawGraphicLayer2.clear();
        this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer2, true);
      }
      this.$GLOBAL.markDrawGraphicLayer2 = new mars3d.layer.GraphicLayer({
        hasEdit: true,
        isAutoEditing: true, //绘制完成后是否自动激活编辑
      });
      this.$GLOBAL.map.addLayer(this.$GLOBAL.markDrawGraphicLayer2);

      this.$refs.markRecord.markRecord_click();
      this.open_mark_box = "MarkRecord";
      this.$refs.markRecord.addMark(fdata, mType);
    },
    //目录树添加新增的标记
    addMarkRecord(data) {
      this.$refs.MarkListTree.treeAddItem(data);
      this.getData.push(data);
    },
    // 弹出表单修改标记弹窗。
    async editMarkRecord(data) {
      // console.log(666666666666666);
      // console.log(JSON.parse(JSON.stringify(data)));
      let fdata = this.getData.filter(function(fp) {
        return fp.markType === "directory" && fp.id !== data.id;
      });
      let tempFileList = [];
      //在这里根据localFiles获取文件列表并展示。
      if (data.localFiles) {
        let tempArr = data.localFiles.split(",");
        for (let i = 0; i < tempArr.length; i++) {
          let fData = {
            id: parseInt(tempArr[i]),
          };
          //console.log('555' + i)
          await getFileDetail(fData)
            .then((res) => {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log('66666666666'+i)
              if (res.data.success && res.data.data) {
                let fileObj = {
                  name: res.data.data.fileOriginName,
                  //如果要预览文件或下载文件则调用专门的api接口，因此这里不需要拼接出url。
                  url: "#",
                  id: fData.id,
                  //'url': process.env.VUE_APP_BASE_API + response.imgUrl
                };
                tempFileList.push(fileObj);
                // console.log(res.data.data);
                // console.log('888888888'+i)
              }
            })
            .catch(function(err) {
              console.log(err);
            });
        }
        // tempArr.map(function(i) {
        // 	let fData = {
        // 		id: parseInt(i)
        // 	}
        // 	await getFileDetail(fData).then(res => {
        // 		console.log(JSON.parse(JSON.stringify(res)));
        // 		console.log('66666666666')
        // 		if (res.data.success && res.data.data) {
        // 			console.log(res.data.data);
        // 			console.log('888888888')
        // 		}
        // 	}).catch(function(err) {
        // 		console.log(err)
        // 	})
        // 	//alert(i)
        // })
        //alert(data.localFiles)
      }
      data.fileList = tempFileList;
      // console.log(JSON.parse(JSON.stringify(tempFileList)));
      // console.log('99999999999')
      // return false;

      this.$refs.markRecord.editMark(data, fdata);
      this.open_mark_box = "MarkRecord";
      // console.log(8888888888888);
      // console.log(JSON.parse(JSON.stringify(data)));
      this.markNodeClick(data);
    },
    //根据标记对象uid找到编辑对象的数据
    findMarkRecordByUid(uid) {
      return this.getData.filter(function(fp) {
        return fp.uid === uid;
      });
    },
    //根据标记对象id弹出编辑对象的弹窗，适用于用户直接在地图上移动标记时触发该标记的编辑弹窗。
    editMarkRecordByUid(mType, uid, tempData = null) {
      let markdata = this.findMarkRecordByUid(uid);
      //alert(point)
      if (markdata && markdata.length > 0) {
        //避免地图上标记点移动位置后，移动前弹出表单里填写的信息被重置，且与地图标识显示不同。
        let nowFormData = this.$refs.markRecord.data;
        let showData = markdata[0];
        // console.log(55555555555555555555555);
        // console.log(JSON.parse(JSON.stringify(nowFormData)));
        // console.log(JSON.parse(JSON.stringify(showData)));
        //要考虑到一种情况，就是markRecord弹窗还在时，切换了移动的标记。
        if (
          nowFormData.id === showData.id &&
          JSON.stringify(nowFormData) != "{}"
        ) {
          //let itemArr=['parentId','name','desc','position','fileList','fileData','markIconColor','markTextColor','markShared'];
          if (nowFormData.parentId) {
            showData.parentId = nowFormData.parentId;
          }
          if (nowFormData.name) {
            showData.name = nowFormData.name;
          }
          if (nowFormData.desc) {
            showData.desc = nowFormData.desc;
          }
          // alert(nowFormData.position)
          if (nowFormData.position) {
            showData.position = nowFormData.position;
          }

          if (nowFormData.fileList) {
            showData.fileList = nowFormData.fileList;
          }
          if (nowFormData.fileData) {
            showData.fileData = nowFormData.fileData;
          }

          if (nowFormData.markIconColor) {
            showData.markIconColor = nowFormData.markIconColor;
          }
          if (nowFormData.markTextColor) {
            showData.markTextColor = nowFormData.markTextColor;
          }
          if (nowFormData.markShared !== undefined) {
            showData.markShared = nowFormData.markShared;
          }
          if (nowFormData.mType) {
            showData.mType = nowFormData.mType;
          }
          if (nowFormData.points) {
            showData.points = nowFormData.points;
          }
          //showData=nowFormData;
        }
        if (mType) {
          showData.mType = mType;
          if (tempData) {
            if (mType === "point") {
              showData.position = tempData;
            }
            if (mType === "polyline" || mType === "polygon") {
              showData.points = tempData;
            }
          }
        }

        // console.log(newXYZ)
        // console.log(showData.position)
        //console.log(JSON.parse(JSON.stringify(showData)));
        this.$refs.MarkListTree.markEdit(showData);
      }
      // console.log(8888888888888);
      // console.log(JSON.parse(JSON.stringify(markdata)));
    },
    // 目录树更新已修改成功的标记。
    updateMarkRecord(data) {
      this.$refs.MarkListTree.treeEditItem(data);
    },
    // 删除节点
    deleteMarkRecord(data) {
      let that = this;
      this.$confirm("确定删除该标记吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除树节点
          if (data.children == undefined || data.children.length <= 0) {
            //axios请求删除节点代码
            let mrdData = {
              projectId: parseInt(
                window.sessionStorage.getItem("nowProjectId")
              ),
              id: data.id,
            };
            deleteMark(mrdData).then((res) => {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log(444444444444);
              if (res.data.success && res.data.code === 204) {
                that.open_mark_box = ""; //清除标记的时候先关闭编辑标记表单，避免标记没了，信息还可以提交。

                that.$GLOBAL.markDrawGraphicLayer.removeGraphic(
                  that.$GLOBAL.markDrawGraphicLayerObj
                );

                that.initTreeData(); //请求后台数据刷新
                //that.$refs.MarkListTree.treeDeleteItem(data); //本地刷新，演示效果用,但会导致一个问题，就是旧数据里的数据没有更新。

                that.$notify({
                  title: "已成功删除该标记。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert("删除该标记失败了，请再试一次吧~", "删除失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });

            if (data.localFiles) {
              let tempArr = data.localFiles.split(",");

              for (let i = 0; i < tempArr.length; i++) {
                let fData = {
                  id: parseInt(tempArr[i]),
                };
                //逐个删除该标记的文件
                deleteFile(fData)
                  .then((res) => {
                    // console.log(JSON.parse(JSON.stringify(res)));
                    // alert(fData.id);
                    // console.log(777);
                  })
                  .catch(function(err) {
                    console.log(err);
                  });
              }
            }
          } else {
            this.$alert("删除失败，因为该目录不为空目录。", "友情提示", {
              confirmButtonText: "确定",
              callback: (action) => {},
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    markNodeClick(data) {
      // console.log(data);
      // console.log(44444444444);

      //alert(data.markType);
      if (data.uid) {
        let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(data.uid);
        this.$GLOBAL.markDrawGraphicLayerObj = layer;
        // console.log(layer);
        // console.log(layer._points);
        // console.log(layer._positions);
        // return false;
        if (data.markType === "polyline" || data.markType === "polygon") {
          // 注意这里应该是定位到layer._points，而不是layer._positions。对于polygon和polyline，layer._positions是一个回调函数CallbackProperty，会导致页面卡死。
          this.$GLOBAL.map.flyToPositions(layer._points, {
            minHeight: 100,
            maxHeight: 5000,
            duration: 2,
          });
        } else {
          layer.flyTo({
            minHeight: 100,
            maxHeight: 5000,
            duration: 2,
          });
        }

        // console.log(layer);
        // console.log(111);
        layer.hasEdit = true;
        this.$refs.markRecord.bindMourseClick(true, data.markType);
      }
    },
    initMarkArray(data) {
      // console.log(data);
      // console.log(1111111);
      //根据数据库加载出来的项目的标记数据显示到地图上。
      if (!this.$GLOBAL.markDrawGraphicLayer) {
        //alert(1);
        this.$GLOBAL.markDrawGraphicLayer = new mars3d.layer.GraphicLayer({
          hasEdit: true,
          isAutoEditing: true, //绘制完成后是否自动激活编辑
        });
        this.$GLOBAL.map.addLayer(this.$GLOBAL.markDrawGraphicLayer);

        let that = this;
        this.$GLOBAL.markDrawGraphicLayer.on(
          mars3d.EventType.editMovePoint,
          function(e) {
            //console.log('编辑修改了点', e)
            let mType = e.graphic.options.type;
            // 地图对象里点标记对应的类型名是“billboard”，而不是“point”。
            if (mType === "billboard") {
              console.log("创建完成", e.graphic._position_draw);
              var point = mars3d.LngLatPoint.fromCartesian(
                e.graphic._position_draw
              );
              point.format(); //经度、纬度、高度

              let currJD = point.lng;
              let currWD = point.lat;
              let currGD = point.alt;
              let cartesianXYZ = currJD + "," + currWD + "," + currGD;
              EventBus.$emit("updateCartesian", {
                cartesianXYZ: cartesianXYZ,
                graphic: e.graphic,
                mType: "point",
              });
              // alert(cartesianXYZ)
              // console.log(currJD,currWD,currGD);
            } else if (mType === "polyline" || mType === "polygon") {
              //console.log('地图里编辑区域标记修改了点（鼠标左键松开时触发）', e);
              let points = that.$refs.markRecord.handleCartsian3Points(
                e.graphic._positions_draw
              );
              if (points) {
                EventBus.$emit("updateCartesian", {
                  graphic: e.graphic,
                  mType: mType,
                  points: points,
                });
              } else {
                that.$alert(
                  "修改该标记出错了，请关闭弹窗后，再尝试修改一次吧~",
                  "错误提示",
                  {
                    confirmButtonText: "确定",
                    type: "error",
                    callback: (action) => {},
                  }
                );
              }
            }
          }
        );
      }

      let iurl, gl, tposition;
      // console.log(JSON.parse(JSON.stringify(data)));
      // console.log(333);
      //this.$GLOBAL.markDrawGraphicLayerArray.length = 0;
      this.$GLOBAL.markDrawGraphicLayer.clear();
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].markType === "point") {
          // if (!data[i].markIconColor) {
          if (!data[i]["markIconColor"]) {
            data[i]["markIconColor"] = this.$GLOBAL.default_markIconColor;
          }
          iurl =
            "/img/marker/mark" + data[i]["markIconColor"].slice(1) + ".png";
          tposition = data[i].position.split(",");

          gl = this.$GLOBAL.markDrawGraphicLayer.addGraphic([
            {
              type: "billboard",
              position: new mars3d.LngLatPoint(
                tposition[0],
                tposition[1],
                tposition[2]
              ),
              style: {
                image: iurl,
                //position: data[i].position,
                label: {
                  //不需要文字时，去掉label配置即可
                  text: data[i].name,
                  font_size: 26,
                  font_family: "黑体",
                  color: data[i]["markIconColor"],
                  outline: true,
                  pixelOffsetY: -66,
                  visibleDepth: false,
                },
                visibleDepth: false,
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
                // clampToGround: true, //贴地
              },
            },
          ]);
          //gl.position=data[i].position;
          // console.log(gl);
          // console.log(gl[0]._id);
          //console.log(this.$GLOBAL.markDrawGraphicLayer);
          //this.$GLOBAL.markDrawGraphicLayerArray.push(gl);
          data[i].uid = gl[0]._id;
        } else if (data[i].markType === "polyline") {
          // console.log(data[i].points);
          // console.log(this.handlePointsToArray(data[i].points));
          // console.log(12345);
          gl = this.$GLOBAL.markDrawGraphicLayer.addGraphic([
            {
              type: "polyline",
              positions: this.handlePointsToArray(
                data[i].points,
                data[i].markType
              ),
              maxPointNum: 70, //可以限定最大点数，70个点绘制后自动结束
              style: {
                color: data[i]["markIconColor"],
                width: 3,
                clampToGround: true,
                visibleDepth: false,
                label: {
                  //不需要文字时，去掉label配置即可
                  text: data[i].name,
                  font_size: 26,
                  font_family: "黑体",
                  color: data[i]["markTextColor"],
                  clampToGround: true,
                  visibleDepth: false,
                },
              },
            },
          ]);
          data[i].uid = gl[0]._id;
        } else if (data[i].markType === "polygon") {
          gl = this.$GLOBAL.markDrawGraphicLayer.addGraphic([
            {
              type: "polygon",
              positions: this.handlePointsToArray(data[i].points),
              maxPointNum: 70, //可以限定最大点数，70个点绘制后自动结束
              style: {
                color: data[i]["markIconColor"],
                opacity: 0.36,
                outline: true,
                outlineWidth: 2,
                outlineColor: data[i]["markTextColor"],
                clampToGround: true,
                visibleDepth: false,
                opacity: 0.1,
                label: {
                  //不需要文字时，去掉label配置即可
                  text: data[i].name,
                  font_size: 26,
                  font_family: "黑体",
                  color: data[i]["markTextColor"],
                  clampToGround: true,
                  visibleDepth: false,
                },
              },
            },
          ]);
          data[i].uid = gl[0]._id;
        }
        // if(gl){
        // 	data[i].uid = gl[0]._id;
        // }
      }
      this.$GLOBAL.markDrawGraphicLayer.unbindContextMenu(true);
      this.bindLayerContextMenu(this.$GLOBAL.markDrawGraphicLayer);
      return data;
    },
    bindLayerContextMenu(graphicLayer) {
      let that = this;
      graphicLayer.bindContextMenu([
        {
          text: "删除对象",
          iconCls: "fa fa-trash-o",
          show: (event) => {
            const graphic = event.graphic;
            if (!graphic || graphic.isDestroy) {
              return false;
            } else {
              return true;
            }
          },
          callback: function(e) {
            const graphic = e.graphic;
            if (!graphic) {
              return;
            }
            //调用后端接口移除，不应该在这里移除。
            // console.log(e.graphic)
            // console.log(e.graphic.uuid)
            // console.log(121212121212);
            let tempData = that.findMarkRecordByUid(e.graphic.uuid);
            if (tempData[0] && tempData[0].id) {
              that.deleteMarkRecord(tempData[0]);
            }
            //findMarkRecordByUid(uid);
            //graphicLayer.removeGraphic(graphic)
          },
        },
      ]);
    },
    handlePointsToArray(points, markType = "") {
      let rarr = [];

      // 针对 京港澳改扩建BIM数字沙盘 项目 【项目id：222263174357061】的线标记坐标点 进行特殊处理。
      let projectId = window.sessionStorage.getItem("nowProjectId");
      let doSpecial = false;
      if (projectId === "222263174357061" && markType === "polyline") {
        doSpecial = true;
      }
      if (points) {
        let tarr = points.split("|");
        for (let i = 0; i < tarr.length; i++) {
          let t2arr = tarr[i].split(",");
          t2arr = t2arr.map((item) => {
            return Number(item);
          });

          if (!doSpecial) {
            rarr.push(new mars3d.LngLatPoint(t2arr[0], t2arr[1], t2arr[2]));
          } else {
            let tempArr = mars3d.PointTrans.proj4Trans(
              t2arr,
              "+proj=tmerc +lat_0=0 +lon_0=113.75 +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs",
              mars3d.CRS.EPSG4326
            );

            rarr.push(new mars3d.LngLatPoint(...tempArr));
          }
        }
      }
      return rarr;
    },
  },
  watch: {},
  destroyed() {
    if (this.$GLOBAL.markDrawGraphicLayer) {
      this.$GLOBAL.markDrawGraphicLayer.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer, true);
    }
    if (this.$GLOBAL.markDrawGraphicLayer2) {
      this.$GLOBAL.markDrawGraphicLayer2.clear();
      this.$GLOBAL.map.removeLayer(this.$GLOBAL.markDrawGraphicLayer2, true);
    }
    this.$GLOBAL.markDrawGraphicLayer = null;
    this.$GLOBAL.markDrawGraphicLayer2 = null;
    this.$GLOBAL.markDrawGraphicLayerObj = null;

    if (graphicLayer) {
      graphicLayer.clear();
      this.$GLOBAL.map.removeLayer(graphicLayer, true);
      graphicLayer = null;
    }
    // 移除EventBus监听器。
    EventBus.$off("updateCartesian");
  },
};
//console.log(localStorage.getItem(ColorPicker));
